<template>
    <header-index />

    <section class="category-banner flex" style="background-image: url('https://images.leaflypackaging.com/profile/upload/2025/11/24/33fc964c26e13ebcc97a8c90f01587bd_20251124114643A001.webp');">
        <div class="container mx-auto px-4 h-[100%] flex flex-col justify-center">
            <div class="pb-2 content-center">
                <h1 class="leafly-page-title ">Vaporizers & Batteries</h1>
                <p class="leafly-page-second-title max-w-[680px]">Our range of vaporizers and batteries will revolutionize your consuming experience. These products are designed for reliable and efficient operation, delivering a smooth and enjoyable experience every time. Plus, the variety of models available at remarkable wholesale prices makes them a must-have for any business.</p>
            </div>
        </div>
    </section>

    <section>
        <div class="bg-gray-50 py-8">
            <div class="container mx-auto px-4">
                <div class="flex justify-between mb-8 gap-4 overflow-x-auto">
                    <nuxt-link v-for="item in navItemList" :to="item.linkUrl" :key="item.id" class="flex-1 py-6 text-center text-base font-weight-600 transition-colors rounded-md min-w-[150px] border-2 bg-white text-gray-700 border-gray-200 hover:border-green-600" :class="(item.linkUrl && routePath.includes(item.linkUrl.replace('.html',''))) ? 'border-2 border-green-600 text-green-600' : ''">
                        {{ item.name }}
                    </nuxt-link>
                </div>

                <!-- 产品列表 -->
                <div v-if="articlesPage.rows && articlesPage.rows.length > 0" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    <div v-for="item in articlesPage.rows" :key="item.id" class="bg-white border border-gray-100 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all">
                        <div class="relative w-full pt-[100%]">
                            <img :src="item.imageUrl" alt="5 ml Square Oil Grip 'N Turn™ Glass Concentrate - Clear Black" class="absolute top-0 left-0 w-full h-full object-cover p-4" loading="lazy" />
                        </div>
                        <div class="p-4">
                            <h3 class="text-base font-weight-400 mb-2 line-clamp-2 h-12">{{ item.title  }}</h3>
                            <p class="text-sm text-gray-600 mb-4 line-clamp-3 h-14">{{ item.description }}</p>
                            <nuxt-link :to="item.fullUrl" class="block w-full bg-green-600 text-white text-center py-2 rounded-md text-sm font-weight-400 hover:bg-green-700 transition-colors">View Product</nuxt-link>
                        </div>
                    </div>
                </div>

                <!-- 空状态提示 -->
                <div v-else class="empty-state-container">
                    <div class="empty-state-content">
                        <div class="empty-state-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-16 h-16">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <h3 class="empty-state-title">Coming Soon</h3>
                        <p class="empty-state-description">More products will be available soon. Please check back later.</p>
                    </div>
                </div>

                <!-- 产品结束提示 -->
                <div v-if="articlesPage.rows && articlesPage.rows.length > 0" class="flex justify-center mt-12">
                    <div class="flex items-center space-x-1">
                        <page-icon :page-num="props.pageNum" :page-size="props.pageSize" :total="articlesPage.total!" />
                    </div>
                </div>
            </div>
        </div>
    </section>

    <sectionCTA />
    <footerIndex />
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import type { Category, NavItemVo, Tags, Page, Article } from '~/types';
    import headerIndex from '../../components/header/header-index.vue'
    import footerIndex from '../../components/footer/footer-index.vue'
    import sectionCTA from '../../components/common/sectionCTA.vue';
    import pageIcon from '../../components/common/pageIcon.vue';
    import cmsConfig from '~/cmsConfig';
    import cmsUtils from '~/utils/cmsUtils';

    // 接收分类数据
    const props = withDefaults(defineProps<{
        category: Category | null
        tagsList?: Tags[]
        pageSize?: number
        pageNum?: number
    }>(), {
        tagsList: () => [],
        pageSize: 12,
        pageNum: 1
    })

    const routePath = useRoute().path
    const cmsInfo = await cmsUtils.getCmsInfo()
    const navItemList = ref<NavItemVo[]>(cmsUtils.getNavItemTreeByNavIndex("equipment_index", cmsInfo) as NavItemVo[])


    const childCategoryIds = cmsUtils.getChildCategoryIds(props.category!.id, cmsInfo);
    const allCategoryIds = [props.category!.id, ...childCategoryIds];
    const body = {
        "websiteId": cmsInfo!.website.id,
        "categoryIds": allCategoryIds,
        "tagsIds": props.tagsList.map(item => item.id),
        "pageNum": props.pageNum,
        "pageSize": props.pageSize
    }

    const articlesPage = await useHttp("/nuxt/article/list", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: body
    }) as Page<Article>;

    articlesPage.rows.forEach((article: Article) => {
        article.fullUrl = cmsUtils.appendCategoryUrl(props.category!, cmsInfo, "/" + article.titleUrl );
    });

    console.log(articlesPage);
</script>

<style scoped lang="scss">
    .equipment-container {
        width: 100%;


        .hero-section {
            background-size: cover;
            background-position: center;
            padding: 60px 0;
            color: white;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(76, 105, 159, 0.8);
                z-index: 0;
            }

            .navActive {
                border: 2px solid #16a34a;
                color: #16a34a;
            }


        }
    }

    /* 文本截断样式 */
    .line-clamp-2 {
        display: -webkit-box;
        -line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .line-clamp-3 {
        display: -webkit-box;
        -line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    /* 确保图片容器和内容区域有固定高度 */
    .h-12 {
        height: 3rem;
    }

    .h-14 {
        height: 3.5rem;
    }

    /* 空状态样式 */
    .empty-state-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 400px;
        padding: 60px 20px;
    }

    .empty-state-content {
        text-align: center;
        max-width: 500px;
    }

    .empty-state-icon {
        color: #16a34a;
        margin-bottom: 24px;
        display: flex;
        justify-content: center;
    }

    .empty-state-title {
        font-size: 2rem;
        font-weight: 600;
        color: #1f2937;
        margin-bottom: 12px;
    }

    .empty-state-description {
        font-size: 1rem;
        color: #6b7280;
        line-height: 1.6;
    }
</style>
